import * as React from 'react'
import { HotKeys } from 'react-hotkeys'
import OutsideClickHandler from 'react-outside-click-handler'

import { BorderStyle, Box, theme, useClassNames } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'
import useFilter from './useFilter'

const MAX_BODY_WIDTH = theme.dimensions.s360
const MAX_BODY_HEIGHT = theme.dimensions.s360

type Props = {
  header?: React.ReactNode
  body?: React.ReactNode
  footer?: React.ReactNode
  maxWidth?: string
  maxHeight?: string
  onClose?: () => void
}

export default function Content({ header, body, footer, maxWidth, maxHeight, onClose }: Props) {
  const { open, setOpen } = useFilter()
  const cx = useClassNames(styles)

  if (!open) {
    return null
  }

  const handleClose = () => {
    setOpen(false)
    onClose?.()
  }

  const borderStyle: BorderStyle = {
    width: 's1',
    color: 'darker080',
    style: 'solid',
  }

  return (
    <div role="dialog" aria-haspopup="dialog">
      <OutsideClickHandler onOutsideClick={handleClose} useCapture={false}>
        <HotKeys
          keyMap={{
            keyEscape: 'escape',
          }}
          handlers={{
            keyEscape: handleClose,
          }}
        >
          <Box
            borderRadius={{ all: 'abs008' }}
            border={{
              all: borderStyle,
            }}
            boxShadow="s300"
            background="grey000White"
            minWidth="s300"
          >
            {header}
            <Box
              border={{
                top: !!header ? borderStyle : undefined,
                bottom: !!footer ? borderStyle : undefined,
              }}
              className={cx('content')}
              overflowY="auto"
              style={{
                maxWidth: maxWidth ?? MAX_BODY_WIDTH,
                maxHeight: maxHeight ?? MAX_BODY_HEIGHT,
              }}
            >
              {body}
            </Box>
            {footer}
          </Box>
        </HotKeys>
      </OutsideClickHandler>
    </div>
  )
}
